// extracted by mini-css-extract-plugin
module.exports = {"groups_list":"_21620d3522--groups_list--nGxVs"};